import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import TestsRequests from "services/tests";

import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  Button,
  Typography,
  IconButton,
  Box,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import NoteAddIcon from "@material-ui/icons/NoteAdd";
import CloseIcon from "@material-ui/icons/Close";

const useStyles = makeStyles((theme) => ({
  title: {
    textAlign: "center",
    marginBlock: "16px",
    color: theme.palette.grey[500],
  },
  input: {
    display: "none",
  },
  uploaderContainer: {
    width: "60%",
    minWidth: "200px",
    marginInline: "auto",
    marginBlock: "20px",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    borderColor: theme.palette.grey[500],
    borderWidth: "2px",
    borderStyle: "dashed",
    borderRadius: "10px",
  },
  girdContainer: {
    width: "100%",
    margin: "0",
    padding: "0",
  },
  customInput: {
    width: "80%",
    [theme.breakpoints.down("lg")]: {
      width: "100%",
    },
  },
  inputContainer: {
    "& p": {
      fontSize: "14px",
      marginBottom: "10px",
    },
  },
  formControl: {
    width: "100%",
  },
}));

export default function AddBatchWordDialog({ open, handleClose }) {
  const [currentFile, setCurrentFile] = useState(null);
  const [currentFileName, setCurrentFileName] = useState("");
  const [selectedEvent, setSelectedEvent] = useState("");

  const { activeWGEvent } = useSelector(({ events }) => events);

  const dispatch = useDispatch();
  const classes = useStyles();

  const handleFileChange = async (event) => {
    const file = event.target.files[0];
    if (file) {
      setCurrentFile(file);
      setCurrentFileName(file.name);
    }
  };
  const handleUploadAndClose = () => {
    if (currentFile) {
      dispatch(TestsRequests.addBatchWord(currentFile, selectedEvent));
      handleClose();
      setCurrentFile();
      setCurrentFileName("");
    }
  };

  const handleRemove = () => {
    setCurrentFile();
    setCurrentFileName("");
  };

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      fullWidth
      maxWidth={"sm"}
    >
      <DialogContent>
        <DialogContentText id="alert-dialog-description">
          وارد کردن گروهی کلمات
        </DialogContentText>
        <Typography className={classes.title}>
          برای آپلود فایل بر روی آیکون فایل کلیک کنید!
        </Typography>
        <Box className={classes.uploaderContainer}>
          <input
            accept=".csv"
            className={classes.input}
            onChange={handleFileChange}
            id="icon-button-file"
            type="file"
          />
          <label htmlFor="icon-button-file">
            {!currentFile && (
              <IconButton
                color="primary"
                aria-label="upload picture"
                component="span"
              >
                <NoteAddIcon fontSize="large" />
              </IconButton>
            )}
          </label>
          {currentFile && (
            <>
              <IconButton
                color="secondary"
                aria-label="delete picture"
                component="span"
                onClick={handleRemove}
              >
                <CloseIcon />
              </IconButton>
              <Typography>{currentFileName}</Typography>
            </>
          )}
        </Box>
        <Box>
          {activeWGEvent.length === 0 ? (
            <Typography style={{ color: "red", marginBottom: 10 }}>
              لطفا ابتدا یک رویداد فعال ایجاد کنید
            </Typography>
          ) : (
            <FormControl variant="outlined" style={{ width: "100%" }}>
              <InputLabel id="demo-simple-select-outlined-label">
                رویداد
              </InputLabel>
              <Select
                labelId="demo-simple-select-outlined-label"
                id="demo-simple-select-outlined"
                value={selectedEvent}
                onChange={(e) => setSelectedEvent(e.target.value)}
                label="event"
              >
                {activeWGEvent.map((item) => (
                  <MenuItem value={item._id}>{item.title}</MenuItem>
                ))}
              </Select>
            </FormControl>
          )}
        </Box>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleUploadAndClose} color="primary">
          تایید و آپلود
        </Button>
        <Button onClick={handleClose} color="secondary" autoFocus>
          انصراف
        </Button>
      </DialogActions>
    </Dialog>
  );
}
